/* ============================================
   useConversacionesSilenciadas — lectura reactiva del store de chats silenciados
   ============================================ */
import { useSyncExternalStore, useEffect } from 'react'
import {
  cargarSilenciadas,
  snapshotSilenciadas,
  suscribirSilenciadas,
} from '@/lib/conversaciones-silenciadas'

/** Set de ids silenciados por este usuario. Dispara la carga inicial una sola vez. */
export function useConversacionesSilenciadas(): ReadonlySet<number> {
  const silenciadas = useSyncExternalStore(
    suscribirSilenciadas,
    snapshotSilenciadas,
    snapshotSilenciadas,
  )
  useEffect(() => { cargarSilenciadas() }, [])
  return silenciadas
}
